import { NgModule } from "@angular/core";
import { SelectRegionComponent } from "./select-region.component";
import { CommonModule } from "@angular/common";

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
    declarations: [
        SelectRegionComponent
    ],
    imports: [
        CommonModule,
        FGBSharedModule
    ],
    exports: [
        SelectRegionComponent
    ]
})
export class SelectRegionModule{}